//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";

import * as UserPreferenceSchemaLib from "../schemas/UserPreference.js";

import { updateUserPreferences } from "../../../api/routes/v7/userPreference/updateMany.schemas.js";

//
// Constants
//

export const userPreferencesElement = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLScriptElement>(document, "script.session-user-preferences");

//
// Utility Functions
//

export function getValue<T extends keyof UserPreferenceSchemaLib.Store>(key: T): UserPreferenceSchemaLib.Store[T]
{
	const decodedUserPreferencesStore = decodeURI(userPreferencesElement.textContent ?? "{}");

	const parsedUserPreferencesStore = JSON.parse(decodedUserPreferencesStore);

	const userPreferencesStore = UserPreferenceSchemaLib.StoreSchema.parse(parsedUserPreferencesStore);

	return userPreferencesStore[key];
}

export async function updateValue<T extends keyof UserPreferenceSchemaLib.Store>(apiUrl: string, input: HTMLInputElement, key: T, value: UserPreferenceSchemaLib.Store[T])
{
	try
	{
		input.disabled = true;

		const response = await updateUserPreferences(apiUrl,
			{
				[key]: value,
			});
	
		if (!response.success)
		{
			throw new Error(response.errors[0]?.message ?? "Unknown error.");
		}

		userPreferencesElement.textContent = JSON.stringify(response.userPreferencesStore);
	}
	finally
	{
		input.disabled = false;
	}
}